<template>
    <section>
        <v-container>
            <v-row>
                <div class="heading">
                    <span>Découvrez nos services</span>
                    <p>
                        Sportopia est la premiere plateforme en Tunisie de coaching sportif en ligne.
                    </p>
                </div>
            </v-row>
            <v-row>
                <v-col xs="12" sm="12" md="4" lg="3" class="responsive-pad">
                    <div class="post">
                        <div class="header_post">
                            <img src="https://images.unsplash.com/photo-1543604055-dede4512686d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80" alt="">
                        </div>
                        <div class="body_post">
                            <div class="post_content">
                                <h1>Yoga</h1>
                                <p>
                                    Sportopia est la premiere plateforme en Tunisie de coaching sportif en ligne.
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col lg="3" md="4" sm="12" class="responsive-pad">
                    <div class="post">
                        <div class="header_post">
                            <img src="https://images.unsplash.com/photo-1533681904393-9ab6eee7e408?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80" alt="">
                        </div>
                        <div class="body_post">
                            <div class="post_content">
                                <h1>Fitness</h1>
                                <p>
                                    Sportopia est la premiere plateforme en Tunisie de coaching sportif en ligne.
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col lg="3" md="4" sm="12" class="responsive-pad">
                    <div class="post">
                        <div class="header_post">
                            <img src="https://images.unsplash.com/photo-1517130038641-a774d04afb3c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80" alt="">
                        </div>
                        <div class="body_post">
                            <div class="post_content">
                                <h1>Zumba</h1>
                                <p>
                                    Sportopia est la premiere plateforme en Tunisie de coaching sportif en ligne.
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    name: "AppServices"
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:300,400|Poppins:300,400,800&display=swap");
@import url("./../../assets/css/main-css.css");
section{
    background: #f5f5f5;
}
.heading{
    margin: 50px auto;
    text-align: center;
}
.heading span{
    font-size: 28px;
    font-weight: 600;
    display: block;
}
.heading p{
    font-size: 16px;
    font-weight: normal;
}
.post {
  /*width: 350px;*/
  height: 300px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  position: relative;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}
.post:hover {
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}
.post:hover img {
  transform: translatey(-3px) translatex(-5px) scale(1.05);
}
.post .header_post {
  width: 100%;
  height: 60%;
  background: #ddd;
  position: absolute;
  top: 0;
  -webkit-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -moz-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -ms-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -o-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
}
.post .header_post img {
  max-width: 100%;
  height: auto;
  transition: ease-in-out 600ms;
}
.post .body_post {
  width: 100%;
  height: 40%;
  background: #fff;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -moz-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -ms-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  -o-transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
  transition: cubic-bezier(0.68, -0.55, 0.27, 1.55) 320ms;
}
.post .body_post .post_content {
  width: 80%;
  height: 80%;
  background: #fff;
  position: relative;
  text-align: center;
}
.post .body_post .post_content h1 {
  font-size: 20px;
  font-weight: bold;
}
.post .body_post .post_content p {
  font-size: 14px;
  font-weight: normal;
}



@keyframes top {
  0% {
    opacity: 0;
    bottom: -80px;
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}
@keyframes icon {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.3) rotate(-2deg);
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}

.col {
    flex-basis: auto !important;
}

</style>